import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import rainbow from '../../src/images/logo192.png';

const UserLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ phone: "", dob: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.phone || !formData.dob) {
      setError("Please enter both phone number and date of birth.");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const res = await axios.post("https://subk.education.com.ly/back/api/findByPhoneAndDob", formData);

      if (res.data.success) {
        localStorage.setItem("customerToken", res.data.token);
        navigate(`/CutomerPageInfo`);
      } else {
        setError(" لا توجد بيانات مطابقة");
      }
    } catch (error) {
    // axios/network error
    setError("Something went wrong. Please try again.");
  } finally {
    setLoading(false);
  }
  };

  return (
     <div className="page-wraper">           
                <div className="login-account">
                    <div className="row h-100">
                       
                        <div className="col-lg-6 col-md-7 col-sm-12 mx-auto align-self-center">
                            <div className="login-form" style={{backgroundColor:'white'}}>
                                 
                                 <div className="author-media">
                              <center><img width="300px" src={`${rainbow}`} /></center>
                              <center> <h2 className="login-title "><span style={{  color:'black'}} > شركة السبق للتجارة و الصيانة لخدمات الصيانة و قطع الغيار </span></h2> </center>
    
                            </div>
                                <h6 className="login-title "><span style={{  color:'black'}} >الملف الشخصي</span></h6>
                                    
                                 
                                   
                                      
                              {error &&                               
  <div style={{  color:'red'}}  className="bg-red-100 text-red-700 border border-red-500 rounded p-2 my-2">{error}</div>}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="mb-1 text-dark">رقم الهاتف</label>
            <input style={{ color:'black',direction:'rtl' ,backgroundColor:'white', borderColor:' rgba(12, 9, 9, 0.1)'}} 
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="الرجاء ادخال رقم الهاتف"
className="form-control form-control-lg"             />
          </div>

          <div>
            <label className="mb-1 text-dark">ادخل الرمز</label>
            <input style={{ color:'black' ,backgroundColor:'white', borderColor:' rgba(12, 9, 9, 0.1)'}} 
              name="dob"
              defaultValue={formData.dob}
              onChange={handleChange}
className="form-control form-control-lg"             />
          </div>
                                <div className="text-center m-4">

          <button
            type="submit"
            disabled={loading}
className="btn btn-primary btn-block"style={{fontSize:'18px'}}          >
            {loading ? "جاري الانتقال..." : "التالي"}
          </button>
          </div>
        </form>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>  
    
  );
};

export default UserLogin;
